<template>
    <default-modal
        ref="box"
        :title="title"
        :modalWidth="600"
        :confirmTxt="`保存`"
        @confirm="confirm"
    >
        <div class="content">
            <div class="commonLine">
                <div class="left">
                    <span>放置分组：</span>
                </div>
                <div class="right">
                    <select
                        name="barMoveGroupSelector"
                        v-model="groupSelectId"
                        class="sel1"
                    >
                        <option
                            v-for="(item, index) in groupList"
                            :key="index"
                            :value="item.groupId"
                            v-text="item.groupName"
                        ></option>
                    </select>
                </div>
            </div>
        </div>
    </default-modal>
</template>

<script>
import DefaultModal from "_c/modals/defaultModal";
import { mapState } from "vuex";
import { changeBarGroup } from "@/requests/bar";

export default {
    name: "barModals",
    components: {
        DefaultModal
    },
    data() {
        return {
            title: "网吧移动到",
            groupSelectId: "",
            barIds: "",
            successFn: ""
        };
    },
    mounted() {
        window.$modal.barMoveToModal = {};
        window.$modal.barMoveToModal.show = barIds => {
            this.barIds = barIds;
            return new Promise(resolve => {
                this.init(() => {
                    resolve(true);
                });
            });
        };
    },
    computed: {
        ...mapState({
            groupList: state => state.user.barGroupList
        })
    },
    methods: {
        init(fn) {
            this.$refs.box.clearWrong();
            this.groupSelectId = "";
            this.$refs.box.show();
            this.successFn = fn;
        },
        async confirm() {
            this.$refs.box.clearWrong();
            if (!this.groupSelectId) {
                return this.$refs.box.setWrong("请选择分组");
            }
            let res = await changeBarGroup({
                barIds: this.barIds,
                groupId: this.groupSelectId
            });
            if (res.code == 200) {
                this.$refs.box.hide();
                this.successFn();
            } else {
                this.$refs.box.setWrong(res.msg);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/msgbox/_msgBox.scss";
@import "_style/_color.scss";
@import "_style/msgbox/_comMsg.scss";

.content {
    padding-top: 20px;
    height: 100px;
}
</style>
